$.extend($.fn, {
    bDepends: function( dependencies, settings ) {
        // check if bDepends for this element was already created
        var bDepends = $.data( this[ 0 ], "bDepends" );
        if ( bDepends ) {
            return bDepends;
        }

        bDepends = new $.bDepends( dependencies, settings, this[ 0 ] );
        $.data( this[ 0 ], "bDepends", bDepends );
    }
});

$.bDepends = function( dependencies, settings, element ) {
    this.element = element;
    this.dependencies = dependencies;
    this.bDependents = [];
    this.valid = null;
    this.settings = $.extend(true, {}, $.bDepends.defaults, settings);
    this.init( dependencies );
};

$.extend($.bDepends, {

    defaults: {
        onEnable: function() {},
        onDisable: function() {},
        enableClass: '',
        disableClass: ''
    },

    prototype: {

        init: function( ) {
            var self = this;
            $.each( this.dependencies, function( selector, settings ) {

                self.bDependents.push(new $.bDependent( selector, settings, self ));
                self.check();

            });
        },

        check: function() {
            var self = this,
                valid = true;

            $.each( self.bDependents, function( k, bDependent ) {

                if(self.valid == null) {
                    bDependent.check();
                }

                if( !bDependent.isValid() ) {
                    valid = false;
                }
            });

            if(valid) {
                if(self.valid == null || !self.valid) {
                    this.enable();
                }
            } else {
                if(self.valid == null || self.valid) {
                    this.disable();
                }
            }
        },

        enable: function() {
            var self = this;

            self.valid = true;
            $(self.element).addClass(self.settings.enableClass);
            $(self.element).removeClass(self.settings.disableClass);

            self.settings.onEnable(self.element);
        },

        disable: function() {
            var self = this;

            self.valid = false;
            $(self.element).removeClass(self.settings.enableClass);
            $(self.element).addClass(self.settings.disableClass);

            self.settings.onDisable(self.element);
        }

    }
});

$.bDependent = function( selector, settings, bDepends ) {
    this.selector = selector;
    this.settings = $.extend( true, {}, $.bDependent.defaults, settings );
    this.bDepends = bDepends;

    this.init();
};

$.extend($.bDependent, {

    defaults: {
        values: [],
        events: [ 'change', 'keyup' ],
        enabled: false,
        checked: null
    },

    prototype: {

        init: function() {
            var self = this;
            $.each( self.settings.events, function( k, event ) {
                $( self.selector ).on( event, function() {
                    self.check();
                    self.bDepends.check();
                });
            });
            $(self.selector).on();
        },

        check: function() {

            var self = this,
                valid = false;

            if ( self.settings.values.length > 0 ) {
                $.each(self.settings.values, function (k, value) {
                    $.each( $(self.selector), function(k, selector) {
                        if ( ($(selector).is('[type="radio"]') && $(selector).is(':checked') || $(selector).is(':not([type="radio"])')) && $(selector).val() == value ) {
                            valid = true;
                        }
                    });

                });
            }

            if ( self.settings.checked != null ) {
                if( $(self.selector).is(':checked') == self.settings.checked ) {
                    valid = true;
                } else {
                    valid = false;
                }
            }

            self.settings.enabled = valid;
        },

        isValid: function() {
            return this.settings.enabled;
        }

    }

});